import { NewCash } from './orders';
import { oliveApi } from '../index';

const url = `/admin/v1/orders`;

export const createCashApi = async (data: NewCash) => {
  return await oliveApi.POST<NewCash, any>(`${url}`, data);
};

export const getOrderListApi = async (params: {
  page?: number;
  limit?: number;
  sortBy?: string[];
  filter?: { state?: string; method?: string; company?: { id?: number } };
}) => {
  return await oliveApi.GET<any, any>(`${url}`, params);
};

export const receiveOrderByIdApi = async ({ orderId }: { orderId: number }) => {
  return await oliveApi.PATCH<any, any>(`${url}/${orderId}/receive`);
};

export const completeOrderByIdApi = async ({
  orderId,
  amount,
}: {
  orderId: number;
  amount: string;
}) => {
  return await oliveApi.PATCH<any, any>(`${url}/${orderId}/complete`, {
    amount,
  });
};

export const updateVoucherDepositApi = async ({
  isDeposit,
  orderId,
  purchaseNumber,
}: {
  isDeposit: boolean;
  orderId: number;
  purchaseNumber: string;
}) => {
  return await oliveApi.PATCH<any, any>(`${url}/${orderId}/exportvoucher`, {
    isDeposit,
    purchaseNumber,
  });
};
